
import {get as getCookie, remove as removeCookie} from '../lib/cookie';
import {APP_ID} from './config';
import store from '@/store';
import {isArray, find, isNil} from 'lodash';
import queryString from 'query-string';
import {parse as parseQuery} from 'qs';
const devToogle = process.env.NODE_ENV === 'development';

export const ucAppID = +APP_ID;

// 排查Bug
console.log(process.env.NODE_ENV);
console.log(process.env.VUE_APP_VERSION);

const isOffline = process.env.NODE_ENV === 'development' || process.env.VUE_APP_VERSION === 'offline';

export const ucDomain = isOffline ? 'https://cas-off.baidu.com' : 'https://cas.baidu.com';

export const passDomain = isOffline ? 'https://passport.qatest.baidu.com' : 'https://passport.baidu.com';

export const qingduoOfflineDomain = 'aigc-fe-temp.now.baidu.com';

// UC注册链接专用
export const ucReg = 'http://u.baidu.com/ucweb/?module=Reguser&controller=reg&action=index&appid=3#/base';
/**
 * url参数 hack 编码
 * cas.baidu.com 会 decode 原始url参数，导致最终返回的 url 参数丢失。
 * 这里对多个参数关键词 & 进行hack 编码为 _and_
 *
 * @param {string} url pathname
 *
 * @return {string}
 */
export const urlQueryEncode = url => {
    return url.replace(/&/g, '_and_');
};

/**
 * url参数 hack 解码
 * cas.baidu.com 会 decode 原始url参数，导致最终返回的 url 参数丢失。
 * 这里对多个参数关键词 _and_ 替换为原始的编码 &
 *
 * @param {string} url pathname
 *
 * @return {string}
 */
 export const urlQueryDecode = url => {
    return url.replace(/_and_/g, '&');
};

/**
 * 获取登录跳转domain url
 * @param {string} pathname pathname
 * @return {string}
 */
export const getRedirectUrl = pathname => {
    // 本地开发环境不要跳转，直接回login
    // 测试环境，只能接收temp域名
    const domain = window.location.hostname;

    // 预上线环境，也跳回登录页，不要main.do校验，否则会自动跳到擎舵正式域名
    if (process.env.VUE_APP_VERSION === 'dev'
        || (isOffline && domain !== qingduoOfflineDomain)
        || process.env.VUE_APP_VERSION === 'preonline'
    ) {
        return '/login';
    }
    const redirectUrl = '/hairuo/main.do';
    if (pathname) {
        // cas.baidu.com 会多 decode 一步参数，导致最终 返回的rurl 参数丢失，所以这里对多个参数关键词&进行hack 编码
        pathname = urlQueryEncode(pathname);
        return `${redirectUrl}?rurl=${encodeURIComponent(pathname)}`;
    }
    return redirectUrl;
};
/**
 * 获取日期
 * @param {number} count 月数
 * @param {boolean} isBackward 是否向前推日期
 * @return {Date} 目标日期
 */
export const getTargetDate = (count, isBackward = true) => {
    const thirtyDays = [4, 6, 9, 11];// 30天的月份
    const thirtyOneDays = [1, 3, 5, 7, 8, 10, 12]; // 31天的月份
    const currDate = new Date(); // 今天日期
    const year = currDate.getFullYear();
    let month = currDate.getMonth() + 1;
    let targetDateMilli = 0;
    const isLeapYear = !!((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0); // 是否是闰年
    let countDays = 0; // 累计天数
    for (let i = 0; i < count; i++) {
        if (isBackward) {
            month = month - 1 <= 0 ? 12 : month - 1;
        }
        else {
            month = month + 1 > 12 ? 1 : month + 1;
        }
        thirtyDays.includes(month)
            ? (countDays += 30)
            : thirtyOneDays.includes(month)
                ? (countDays += 31)
                : isLeapYear
                    ? (countDays += 29)
                    : (countDays += 28);
    }
    targetDateMilli = currDate.setDate(
        currDate.getDate() - (isBackward ? countDays - 1 : countDays * -1 + 1)
    );
    return new Date(targetDateMilli);
};
/**
 * 发起登出
 */
export const logoutUcAndPass = (pathname = '') => {
    const targetURL = `${ucDomain}?action=logout&u=${location.origin}${encodeURIComponent(pathname)}`;
    const option = {domain: location.host, path: '/'};
    removeCookie(`CPID_${APP_ID}`, option);
    removeCookie(`CPTK_${APP_ID}`, option);
    removeCookie(`__cas__id__${APP_ID}`, option);
    removeCookie(`__cas__st__${APP_ID}`, option);
    window.location.href = targetURL;
};

/**
 * 判断登录状态
 * @return {boolean} 是否登录了
 */
export const checkLoginStatus = () => {
    // 非mock环境，判断是否登录
    if (!devToogle) {
        const CPID = getCookie(`CPID_${APP_ID}`) || '';
        const CPTK = getCookie(`CPTK_${APP_ID}`) || '';
        if ((CPID !== 0 && !CPID) || !CPTK) {
            return false;
        }
        return true;
    }
    return true;
};

// 检查hag里是否包含所需要的权限
export const checkHagRole = (hags = {}, authorizedRole = null) => {
    let needRoleArr = [];
    if (typeof authorizedRole === 'string') {
        needRoleArr = authorizedRole.split(',');
    }
    else if (authorizedRole instanceof Array) {
        needRoleArr = authorizedRole;
    }
    // 可以是数组，有多个权限才能放松
    if (needRoleArr.length > 0) {
        let findNot = needRoleArr.filter(role => {
            return !hags[role];
        });
        return findNot.length < 1;
    }
    return true;
};

/**
 * 判断是否有权限
 * @return {boolean} 是否拥有权限
 */
export const checkUserPermission = role => {
    // 判断是否有权限
    if (!store.state.app.loadingInfo) {
        // if (!(store.state.app.userInfo.bizHags && store.state.app.userInfo.bizHags[role])) {
        //     return false;
        // }
        return checkHagRole(store.state.app.userInfo.bizHags, role);
    }
    return true;
};

/**
 * 从url中获取userid
 * @return {number} userid
 */
export const getUseridFromUrl = () => {
    const urlPath = window.location.pathname;
    const reg = /user\/(\d+)\D?/;
    const res = urlPath.match(reg);
    if (Array.isArray(res)) {
        return parseInt(res[1], 10);
    }
    return '';
};

/**
 * 从url query中获取userid
 *
 * @param {string} search url search info
 * @return {string} userid
 */
export const getUseridFromQuery = (search = '') => {
    const query = queryString.parse(search);
    let userid = query.userid;
    if (isArray(userid)) {
        userid = find(userid, id => !!id);
    }
    return userid || '';
};

/**
 * 从cookie里取出userid
 * @return {string} 登录账号的ID
 */
export const getUseridFromCokkie = () => {
    const CPID = getCookie(`CPID_${APP_ID}`) || '';
    // 非mock环境，判断是否登录
    if (!devToogle || CPID) {
        return CPID;
    }
    return '';
};
/**
 * 从cookie里取出token
 * @return {string} 登录的token
 */
export const getTokenFromCookie = () => {
    const CPTK = getCookie(`CPTK_${APP_ID}`) || '';
    // 非mock环境，判断是否登录
    if (!devToogle || CPTK) {
        return CPTK;
    }
    return '';
};
/**
 * 获取路由参数
 */
export const getRouteQuery = () => {
    const query = parseQuery(window.location.search.slice(1)) || {};
    delete query.taskIdFromAiFront;
    return query;
};

/**
 * 补齐2位数字
 * @param num
 * @returns {*|string}
 */
const getDoubleUnits = num => {
    if (num < 10) {
        return `0${num}`;
    }
    return num;
};

/**
 * 利用时间戳获取不重复的数字
 * @param units 补齐的位数，用于确保随机生成，要求小于8
 * @returns {number}
 */
export const getNonRepeatingNumber = (units = 12) => {
    const date = new Date();
    const year = date.getFullYear().toString().slice(2);
    const month = getDoubleUnits(date.getMonth() + 1);
    const day = getDoubleUnits(date.getDate());
    const hour = getDoubleUnits(date.getHours());
    const minute = getDoubleUnits(date.getMinutes());
    const second = getDoubleUnits(date.getSeconds());
    const randomUnits = units - 12;
    let randomStr = '';
    if (randomUnits > 0) {
        for (let i = 0; i < randomUnits; i++) {
            const randomNumber = Math.floor(Math.random() * 10);
            randomStr += randomNumber.toFixed(0);
        }
    }
    const nonRepeatingNumber = `${year}${month}${day}${hour}${minute}${second}${randomStr}`;
    return Number(nonRepeatingNumber);
};

/**
 * 大图治理：修改图片链接并添加处理条件
 * https://cloud.baidu.com/doc/BOS/s/3ldh5wqnw
 * @param url 图片链接
 * @param condition 处理条件
 * @returns 修改后的图片链接
 */
export const optimizeImgUrl = (url, condition) => {
    if (!url) {
        return '';
    }
    // 旧的链接不能加后缀,直接返回
    if (!condition || url.indexOf('cspd-video-frame') > 0) {
        return url;
    }
    // 检查链接中是否已经包含 "?"
    if (url.includes('?')) {
        // 如果包含 "?"，在末尾添加 "&" 和限制条件
        return `${url}&x-bce-process=image/${condition}`;
    }
    // 如果不包含 "?"，在末尾添加 "?" 和限制条件
    return `${url}?x-bce-process=image/${condition}`;
};


// 判断某个导航选项是否有权限查看
export const checkItemValid = (item, info = {}) => {
    const {hags, userInfo} = info;
    const {isOuterUser, hasUCLience} = userInfo;
    // 外部用户， 且不给外部用户展示的模块
    if (isOuterUser && item.forbidOuterUser) {
        return false;
    }
    // 设置了指定权限下、要隐藏的item
    let hideRole = [];
    if (typeof item.hideRole === 'string') {
        hideRole.push(item.hideRole);
    }
    else if (item.hideRole instanceof Array) {
        hideRole = item.hideRole;
    }
    let check = true;
    hideRole.forEach(role => {
        if (hags[role]) {
            check = false;
            return false;
        }
    });
    if (!check) {
        return false;
    }
    // 设置了指定权限才显示的item
    if (item.authorizedRole && !checkHagRole(hags, item.authorizedRole)) {
        return false;
    }
    // 如果基础权限判断通过，有anyMatch 表示附加的判定条件符合任意一个即可，都不符合则不通过
    if (!isNil(item.anyMatch)) {
        let check = false;
        let {allowInnerUser, authorizedRole} = item.anyMatch;
        if (allowInnerUser && hasUCLience) {
            check = true;
        }
        if (typeof authorizedRole === 'string') {
            authorizedRole = [authorizedRole];
        }
        // role任意一个即可
        authorizedRole.forEach(role => {
            if (hags[role]) {
                check = true;
            }
        });
        // 如果any里的所有条件都不符合，则不允许
        if (check === false) {
            return false;
        }
    }
    // 如果有children但是children为空，也不显示
    if (item.children) {
        let visibleChildren = item.children.filter(child => {
            return checkItemValid(child, info);
        });
        if (visibleChildren.length < 1) {
            return false;
        }
    }
    if (item.isEmpty) {
        return false;
    }
    return true;
};

// 创建枚举值
export const defineEnum = enumObj => {
    const result = {};

    Object.entries(enumObj).forEach(([key, value]) => {
      result[key] = value;
      result[value] = key;
    });
    // 冻结对象，防止被修改
    return Object.freeze(result);
};